import React from 'react';
import { CompetencyStatus, STATUS_DESCRIPTIONS, nextStatus } from '../../config';
import { competencyBadge } from '../../badges';

interface StatusCellProps {
  status: CompetencyStatus;
  /** False when this member is not assessed in this category (greyed out). */
  applicable: boolean;
  /** False for QA / non-manager users — cell renders but is not clickable. */
  canEdit: boolean;
  /** True while this cell's upsert is in flight — further clicks are ignored. */
  pending: boolean;
  onCycle: () => void;
}

const StatusCell: React.FC<StatusCellProps> = ({ status, applicable, canEdit, pending, onCycle }) => {
  if (!applicable) {
    return (
      <td className="status-cell status-cell--na" title="Not applicable for Draftspersons">
        <span className="status-cell__na-mark" aria-hidden="true" />
      </td>
    );
  }

  const tooltip = canEdit
    ? `${status} — ${STATUS_DESCRIPTIONS[status]}\nClick to set: ${nextStatus(status)}`
    : `${status} — ${STATUS_DESCRIPTIONS[status]}`;

  return (
    <td className="status-cell">
      <button
        type="button"
        className={`status-cell__btn${pending ? ' status-cell__btn--pending' : ''}`}
        onClick={onCycle}
        disabled={!canEdit}
        title={tooltip}
        aria-label={`Status: ${status}${canEdit ? ', click to change' : ''}`}
      >
        {competencyBadge(status)}
      </button>
    </td>
  );
};

export default StatusCell;
